/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

import {
  faFileImport,
  faFileInvoiceDollar,
  faSearch,
  faTruck,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Container, Row, Col, Card, Button, Table } from "react-bootstrap"
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import React, { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import TextInput from "../../../components/InputWrapper/TextInput"
import { T表紙分割 } from "../../../components/ComboBox/HyosiBunkatuComboBox"
import { T請求内訳 } from "../../../components/ComboBox/SeikyuUtiwakeComboBox"

import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { Form } from "react-bootstrap"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"

import { useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import { 画面ロック解除 } from "../../../globalStore/progressStore"
import {
  TKaikonZyutyuHaisyaPatternGetRes,
  TKaikonZyutyuHaisyaKoteiPatternGetRes,
} from "../../../service/orderContainer/kaikonZyutyuHaisyaPattern/TKaikonZyutyuHaisyaPattern"

import { 区分分類コード } from "../../../constant/enum/codes"
import RequiredMark from "../../../components/RequiredMark"
import {
  e税込区分,
  e課税区分,
  e工程区分,
  e工程区分名称,
  T工程区分値,
  e海コン付帯作業区分,
} from "../../../constant/enum/zyutuHaisya"
import CONSTANT from "../../../constant"
import _ from "lodash"
import KaikonZyutyuHaisyaPatternService from "../../../service/orderContainer/kaikonZyutyuHaisyaPattern/kaikonZyutyuHaisyaPatternService"
import SagyoGridRow from "./SagyoGridRow"
import NinusiService from "../../../service/master/ninusi/ninusiService"
import { TApiResponse } from "../../../service/TApiResponse"
import { showInfoToast } from "../../../components/CustomToast"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"
import { RootState } from "../../../globalStore/rootreducer"
import NinusiSeikyuSearchModal from "../../../components/SearchModal/NinusiSeikyuSearchModal"
import commonUtil from "../../../ts/util/commonUtil"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import { TNinusiSeikyuListGetRes } from "../../../service/master/ninusiseikyu/TNinusiSeikyu"
import { createコース編集 as createコース編集Inner } from "../KaikonZyutyuHaisyaList/KaikonZyutuHaisyaListGridUtil"

export type T請求支払情報Grid = {
  種別: string
  運送料課税区分コード?: string
  運送料金額: number
  付帯料課税区分コード?: string
  付帯料金額: number
  高速料金税込区分コード?: string
  高速料金額: number
  備考: string
}

/**
 * 海コン受注配車パターン入力
 * @returns
 */
const KaikonZyutyuHaisyaPatternRegister = () => {
  const history = useHistory()
  // const location = useLocation()
  const { id } = useParams<{ id: string }>()
  const dispatch: AppDispatch = useDispatch()

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //TODO:ページ名称確定必須
  // let gridId = "KaikonZyutyuHaisyaPatternRegister_GridId"

  //#region [createCollectionView]

  /**
   * 請求支払情報のcollectionView作成
   * @param data
   * @returns
   */
  const create請求支払CollectionView = (
    data?: TKaikonZyutyuHaisyaPatternGetRes,
    荷主請求List?: TNinusiSeikyuListGetRes[] | undefined
  ) => {
    let 高速料税込区分コード: string = e税込区分.税込
    if (荷主請求List) {
      const 荷主請求 = 荷主請求List.find(
        (i) => i.荷主請求ID === data?.荷主請求ID
      )
      高速料税込区分コード = 荷主請求
        ? 荷主請求.高速料税込区分コード
        : e税込区分.税込
    }
    const 請求情報: T請求支払情報Grid = {
      種別: "請求",
      運送料課税区分コード: data?.請求運送料課税区分コード ?? e課税区分.課税,
      運送料金額: data?.請求運送料 ?? 0,
      付帯料課税区分コード: data?.請求付帯料課税区分コード ?? e課税区分.課税,
      付帯料金額: data?.請求付帯料 ?? 0,
      高速料金税込区分コード: 高速料税込区分コード,
      高速料金額: data?.請求高速料 ?? 0,
      備考: data?.請求備考 ?? "",
    }

    const 支払情報: T請求支払情報Grid = {
      種別: "支払",
      運送料課税区分コード: data?.支払運送料課税区分コード ?? e課税区分.課税,
      運送料金額: data?.支払運送料 ?? 0,
      付帯料課税区分コード: data?.支払付帯料課税区分コード ?? e課税区分.課税,
      付帯料金額: data?.支払付帯料 ?? 0,
      高速料金税込区分コード: 高速料税込区分コード,
      高速料金額: data?.支払高速料 ?? 0,
      備考: data?.支払備考 ?? "",
    }

    return new wjCore.CollectionView<T請求支払情報Grid>([請求情報, 支払情報])
  }
  const userInfo = useSelector((state: RootState) => state.user.LoginUserInfo)
  const createInit作業情報 = (
    工程区分: T工程区分値
  ): Partial<TKaikonZyutyuHaisyaKoteiPatternGetRes> => ({
    受注配車工程パターンID: undefined,
    工程区分コード: 工程区分.toString(),
    工程区分名称1: e工程区分名称[工程区分].toString(),
    運行部所コード: userInfo.部所コード,
  })
  const [initPICK情報, setInitPICK情報] = useState<
    TKaikonZyutyuHaisyaKoteiPatternGetRes | undefined
  >(createInit作業情報(e工程区分.PICK))
  const [init作業情報, setInit作業情報] = useState<
    TKaikonZyutyuHaisyaKoteiPatternGetRes | undefined
  >(createInit作業情報(e工程区分.作業))
  const [init返却情報, setInit返却情報] = useState<
    TKaikonZyutyuHaisyaKoteiPatternGetRes | undefined
  >(createInit作業情報(e工程区分.返却))
  const [initその他情報, setInitその他情報] = useState<
    TKaikonZyutyuHaisyaKoteiPatternGetRes | undefined
  >(createInit作業情報(e工程区分.その他))
  //#endregion
  //#region [state]

  const [isSearching, setIsSearching] = useState(false)
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>([])

  const [searchResult, setSearchResult] =
    useState<TKaikonZyutyuHaisyaPatternGetRes>()

  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主ID, set荷主ID] = useState<number>()
  const [荷主名, set荷主名] = useState<string>()
  const [荷主請求ID, set荷主請求ID] = useState<number | null>()
  const 荷主請求Ref = useRef<number | null>()
  const [荷主請求ItemSource, set荷主請求ItemSource] = useState<T表紙分割[]>()

  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>([])

  const [受注パターンコード, set受注パターンコード] = useState<string>()
  const [受注パターン名, set受注パターン名] = useState<string>()
  const [受注部所コード, set受注部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >()
  const [コンテナサイズ区分コード, setコンテナサイズ区分コード] = useState<
    string | null
  >()
  const [コンテナ軸区分コード, setコンテナ軸区分コード] = useState<
    string | null
  >()

  const [PICK情報, setPICK情報] =
    useState<TKaikonZyutyuHaisyaKoteiPatternGetRes>()
  const [作業情報, set作業情報] =
    useState<TKaikonZyutyuHaisyaKoteiPatternGetRes>()
  const [返却情報, set返却情報] =
    useState<TKaikonZyutyuHaisyaKoteiPatternGetRes>()
  const [その他情報, setその他情報] =
    useState<TKaikonZyutyuHaisyaKoteiPatternGetRes>()
  const [更新日時, set更新日時] = useState<string>()
  const [計上基準日区分コード, set計上基準日区分コード] = useState<string>()
  const [計上基準日区分名称, set計上基準日区分名称] = useState<string>()
  const [請求内訳id, set請求内訳id] = useState<number | null>()
  const [請求内訳ItemSource, set請求内訳ItemSource] = useState<T請求内訳[]>()

  const [請求支払情報, set請求支払情報] = useState<{
    data: wjCore.CollectionView<T請求支払情報Grid>
  }>({ data: create請求支払CollectionView() })

  const [コース編集, setコース編集] = useState<string>()

  const [課税区分DataMap, set課税区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [税込区分DataMap, set税込区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()
  const [付帯作業分類区分List, set付帯作業分類区分List] = useState<
    T区分マスタ[]
  >([])
  const [請求flexGrid, set請求FlexGrid] = useState<wjcGrid.FlexGrid>()
  // 荷主検索
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)
  // 登録確認モーダル
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  // 削除確認モーダル
  const [isConfirmDeleteModalShow, setIsConfirmDeleteModalShow] =
    useState(false)

  // エラー表示用フラグ
  const [isInvalidパターンコード, setIsInvalidパターンコード] =
    useState<boolean>(false)
  const [isInvalid荷主コード, setIsInvalid荷主コード] = useState<boolean>(false)
  const [isInvalid表紙名, setIsInvalid表紙名] = useState<boolean>(false)
  const [isInvalid受注部所, setIsInvalid受注部所] = useState<boolean>(false)
  const [isInvalid請求内訳, setIsInvalid請求内訳] = useState<boolean>(false)

  //#endregion

  //#region [comboboxState]

  // 表紙分割
  const [表紙分割ComboBox, set表紙分割ComboBox] = useState<TWijmoComboBox<
    T表紙分割["荷主請求ID"],
    T表紙分割
  > | null>(null)
  const [表紙分割IsLoadEnded, set表紙分割IsLoadEnded] = useState<boolean>(false)
  // 請求内訳
  const [請求内訳ComboBox, set請求内訳ComboBox] = useState<TWijmoComboBox<
    T請求内訳["荷主請求内訳ID"],
    T請求内訳
  > | null>(null)
  const [請求内訳IsLoadEnded, set請求内訳IsLoadEnded] = useState<boolean>(false)

  // コンテナサイズ
  const [コンテナサイズComboBox, setコンテナサイズComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [コンテナサイズIsLoadEnded, setコンテナサイズIsLoadEnded] =
    useState<boolean>(false)

  // コンテナ軸
  const [コンテナ軸ComboBox, setコンテナ軸ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [コンテナ軸IsLoadEnded, setコンテナ軸IsLoadEnded] =
    useState<boolean>(false)

  // 受注部所
  const [受注部所ComboBox, set受注部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [受注部所isLoadEnded, set受注部所isLoadEnded] = useState<boolean>(false)

  //#region grid操作
  //grid初期化フラグ
  const [請求支払GridInitialized, set請求支払GridInitialized] =
    useState<boolean>(false)
  // リストア制御用フラグ
  const [
    ,
    // isRestoreSearching
    setIsRestoreSearching,
  ] = useState<boolean>(false)

  // 画面初期化フラグ
  const [comboDataInitialized, setComboDataInitialized] = useState(false)
  const [pageInitialized, setPageInitialized] = useState(false)
  //#endregion

  //登録時画面遷移判定用
  const [isPageMove, setIsPageMove] = useState<boolean>(false)

  //#endregion

  //#region [effect]
  // 初期設定
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      set部所ItemSource(部所ListRes.data)
      set区分ItemSource(区分マスタRes.data)
      set課税区分DataMap(
        new wjcGrid.DataMap<T区分マスタ>(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.課税区分
          ),
          "区分コード",
          "名称1"
        )
      )
      set税込区分DataMap(
        new wjcGrid.DataMap<T区分マスタ>(
          区分マスタRes.data.filter(
            (d) => d.分類コード === 区分分類コード.受注配車_請求支払.税込区分
          ),
          "区分コード",
          "名称1"
        )
      )

      set付帯作業分類区分List(
        区分マスタRes.data.filter(
          (d) =>
            d.分類コード === 区分分類コード.受注配車_請求支払.海コン付帯作業区分
        )
      )
      setComboDataInitialized(true)
    })
  }, [])

  //  荷主請求idの切り替えに合わせて請求内訳の表示データを変更
  useEffect(() => {
    if (請求内訳ComboBox != null) {
      請求内訳ComboBox.collectionView.filter = (item) => {
        return item.荷主請求ID === 荷主請求ID || item.荷主請求内訳ID === 0
      }
      請求内訳ComboBox.isDisabled = ![
        ...請求内訳ComboBox.collectionView.items,
      ].find((item) => {
        return item.荷主請求ID === 荷主請求ID
      })
      請求内訳ComboBox.collectionView.refresh()
      請求内訳ComboBox.refresh()
    }
  }, [荷主コード, 荷主請求ID])

  //useEffect内ではasyncが使用できないため外部に記述
  const 荷主取得 = async (荷主コード?: string) => {
    if (荷主コード == null || wjCore.isNullOrWhiteSpace(荷主コード ?? "")) {
      set荷主名("")
      set荷主ID(undefined)
      set荷主請求ItemSource([])
      set請求内訳ItemSource([])
      return
    }
    try {
      const 荷主res = await new NinusiService().getList({
        荷主コード,
        完全一致フラグ: true,
      })

      if (荷主res != null && 荷主res.data.length > 0) {
        const 荷主 = 荷主res.data[0]
        set荷主名(荷主.荷主名)
        set荷主ID(荷主.荷主ID)
        const ninusiService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiService.getList({
          荷主Id: 荷主.荷主ID,
        })
        if (荷主請求res != null && 荷主請求res.data.length > 0) {
          set荷主請求ItemSource([
            ..._.orderBy(荷主請求res.data, ["荷主コード", "表紙分割コード"]),
          ])
          const 請求内訳Res = await ninusiService.getListUchiwake({
            荷主請求IdList: [...荷主請求res.data.map((d) => d.荷主請求ID)],
          })
          if (請求内訳Res != null && 請求内訳Res.data.length > 0) {
            set請求内訳ItemSource([
              ..._.orderBy(請求内訳Res.data, ["請求内訳コード"]),
            ])
          } else {
            set請求内訳ItemSource([])
          }
        } else {
          set荷主請求ItemSource([])
          set請求内訳ItemSource([])
        }
      } else {
        set荷主名("")
        set荷主ID(undefined)
        set荷主請求ItemSource([])
        set請求内訳ItemSource([])
      }
    } catch (error) {
      dispatch(setAlerts(error))
      set荷主名("")
      set荷主ID(undefined)
      set荷主請求ItemSource([])
      set請求内訳ItemSource([])
    }
  }
  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    if (
      comboDataInitialized &&
      請求支払GridInitialized &&
      表紙分割ComboBox &&
      請求内訳ComboBox &&
      受注部所ComboBox
    ) {
      setPageInitialized(true)
    }
  }, [
    comboDataInitialized,
    請求支払GridInitialized,
    表紙分割ComboBox,
    請求内訳ComboBox,
    受注部所ComboBox,
  ])

  useEffect(() => {
    if (請求内訳ComboBox != null) {
      請求内訳ComboBox.collectionView.filter = (item) => {
        return item.荷主請求ID === 荷主請求ID || item.荷主請求内訳ID === 0
      }
      請求内訳ComboBox.isDisabled = ![
        ...請求内訳ComboBox.collectionView.items,
      ].find((item) => {
        return item.荷主請求ID === 荷主請求ID
      })
      // 荷主請求内訳idが表示可能なアイテムにない場合データをnullに変更
      const 荷主請求内訳data = [...請求内訳ComboBox.collectionView.items].find(
        (item) => {
          return (
            item.荷主請求ID === 荷主請求ID && item.荷主請求内訳ID === 請求内訳id
          )
        }
      )
      if (!荷主請求内訳data) {
        set請求内訳id(null)
      }
      請求内訳ComboBox.collectionView.refresh()
      請求内訳ComboBox.refresh()
    }
  }, [荷主ID, 荷主請求ID])

  useEffect(() => {
    if (請求flexGrid) {
      const 請求GridData: T請求支払情報Grid[] =
        請求flexGrid.collectionView.sourceCollection
      請求GridData[0].付帯料金額 =
        (PICK情報?.海コン付帯作業手当 ?? 0) +
        (作業情報?.海コン付帯作業手当 ?? 0) +
        (返却情報?.海コン付帯作業手当 ?? 0) +
        (その他情報?.海コン付帯作業手当 ?? 0)

      請求GridData[0].高速料金額 =
        (PICK情報?.海コン付帯高速料 ?? 0) +
        (作業情報?.海コン付帯高速料 ?? 0) +
        (返却情報?.海コン付帯高速料 ?? 0) +
        (その他情報?.海コン付帯高速料 ?? 0)

      if (!請求GridData[0].備考) {
        const 付帯作業区分コード =
          PICK情報?.海コン付帯作業区分コード ??
          作業情報?.海コン付帯作業区分コード ??
          返却情報?.海コン付帯作業区分コード ??
          その他情報?.海コン付帯作業区分コード ??
          null
        if (
          付帯作業区分コード &&
          付帯作業区分コード !== e海コン付帯作業区分.フォーク作業
        ) {
          請求GridData[0].備考 = 付帯作業分類区分List.filter(
            (d) => d.区分コード === 付帯作業区分コード
          )[0].名称1
        }
      }
      請求flexGrid.refresh()
    }

    createコース編集()
  }, [PICK情報, 作業情報, 返却情報, その他情報])

  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (!pageInitialized) return
    if (請求支払GridInitialized) {
      //初回filter作成時にidがいた場合、検索を行う
      if (id != null && id !== "") {
        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(id)
          .then((res) => {
            if (res && res.data) {
              setData(res.data)
              荷主請求Ref.current = res.data.荷主請求ID
            }
          })
          .finally(() => {
            dispatch(画面ロック解除())
            請求flexGrid?.refresh()
          })
      } else {
        set受注部所コード(userInfo.部所コード)
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [pageInitialized])

  //  荷主請求idの切り替えに合わせて請求内訳の表示データを変更
  useEffect(() => {
    if (請求内訳ComboBox != null) {
      請求内訳ComboBox.collectionView.filter = (item) => {
        return item.荷主請求ID === 荷主請求ID || item.荷主請求内訳ID === 0
      }
      請求内訳ComboBox.isDisabled = ![
        ...請求内訳ComboBox.collectionView.items,
      ].find((item) => {
        return item.荷主請求ID === 荷主請求ID
      })
      // 荷主請求内訳idが表示可能なアイテムにない場合データをnullに変更
      const 荷主請求内訳data = [...請求内訳ComboBox.collectionView.items].find(
        (item) => {
          return (
            item.荷主請求ID === 荷主請求ID && item.荷主請求内訳ID === 請求内訳id
          )
        }
      )
      if (!荷主請求内訳data) {
        set請求内訳id(null)
      }
      請求内訳ComboBox.collectionView.refresh()
      請求内訳ComboBox.refresh()
    }
  }, [荷主ID, 荷主請求ID])

  useEffect(() => {
    // 荷主請求ID変更時は高速料税込区分も変更する
    if (荷主請求ID && 請求flexGrid) {
      const 荷主請求Data = 荷主請求ItemSource?.find(
        (i) => i.荷主請求ID === 荷主請求ID
      )
      if (荷主請求Data) {
        const 請求source: T請求支払情報Grid[] =
          請求flexGrid.collectionView.sourceCollection
        請求source.forEach(
          (a) => (a.高速料金税込区分コード = 荷主請求Data.高速料税込区分コード)
        )
        請求flexGrid.collectionView.refresh()
        請求flexGrid.refresh()
      }
    }
  }, [荷主請求ID, 請求flexGrid])

  //請求内訳の変更に合わせて計上基準日も変更する
  useEffect(() => {
    if (請求内訳id) {
      const 請求内訳 = 請求内訳ItemSource?.find(
        (i) => i.荷主請求内訳ID === 請求内訳id
      )
      if (請求内訳) {
        set計上基準日区分名称(請求内訳.計上基準日区分名称1)
        set計上基準日区分コード(請求内訳.計上基準日区分コード)
      } else {
        set計上基準日区分名称("")
        set計上基準日区分コード("")
      }
    } else {
      set計上基準日区分名称("")
      set計上基準日区分コード("")
    }
  }, [請求内訳id, 請求内訳ItemSource])

  //#endregion

  //#region [method]

  /**
   * 検索
   */
  const search = async (id: string) => {
    setIsSearching(true)
    dispatch(clearAlert()) // アラートを非表示に

    try {
      const service = new KaikonZyutyuHaisyaPatternService()

      const res = await service.get(id)
      setSearchResult(res.data)
      if (res.data) {
        setData(res.data)
        setPICK情報(
          res.data.PICK受注配車工程 ?? createInit作業情報(e工程区分.PICK)
        )
        set作業情報(
          res.data.作業受注配車工程 ?? createInit作業情報(e工程区分.作業)
        )
        set返却情報(
          res.data.返却受注配車工程 ?? createInit作業情報(e工程区分.返却)
        )
        setその他情報(
          res.data.その他受注配車工程 ?? createInit作業情報(e工程区分.その他)
        )
        setInitPICK情報(
          res.data.PICK受注配車工程 ?? createInit作業情報(e工程区分.PICK)
        )
        setInit作業情報(
          res.data.作業受注配車工程 ?? createInit作業情報(e工程区分.作業)
        )
        setInit返却情報(
          res.data.返却受注配車工程 ?? createInit作業情報(e工程区分.返却)
        )
        setInitその他情報(
          res.data.その他受注配車工程 ?? createInit作業情報(e工程区分.その他)
        )
        // comboboxのループ対応のため初期値用のstateに入れる

        // 紐づいたデータに応じて荷主請求と請求内訳を取得し設定する
        const ninusiService = new NinusiSeikyuService()
        const 荷主請求res = await ninusiService.getList({
          荷主Id: res.data.荷主ID,
        })

        set請求支払情報({
          data: create請求支払CollectionView(res.data, 荷主請求res?.data),
        })

        if (荷主請求res != null && 荷主請求res.data.length > 0) {
          set荷主請求ItemSource([
            ..._.orderBy(荷主請求res.data, ["荷主コード", "表紙分割コード"]),
          ])

          const 請求内訳Res = await ninusiService.getListUchiwake({
            荷主請求IdList: [...荷主請求res.data.map((d) => d.荷主請求ID)],
          })
          if (請求内訳Res != null && 請求内訳Res.data.length > 0) {
            set請求内訳ItemSource([
              ..._.orderBy(請求内訳Res.data, ["請求内訳コード"]),
            ])
          } else {
            set請求内訳ItemSource([])
          }
          return res
        } else {
          set荷主請求ItemSource([])
          set請求内訳ItemSource([])
          return res
        }
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false)
    }
  }

  const createコース編集 = () => {
    let コース編集Text = createコース編集Inner({
      PICK情報: PICK情報 ?? undefined,
      作業情報: 作業情報 ?? undefined,
      返却情報: 返却情報 ?? undefined,
      その他情報: その他情報 ?? undefined,
    })

    if (wjCore.isNullOrWhiteSpace(コース編集Text)) return
    setコース編集(コース編集Text)
  }

  /**
   * 画面の単項目にデータを設定する
   * @param data
   */
  const setData = (data: TKaikonZyutyuHaisyaPatternGetRes) => {
    set受注パターンコード(data.受注配車パターンコード)
    set受注パターン名(data.受注配車パターン名)
    set受注部所コード(data.受注部所コード ?? "")
    set荷主コード(data.荷主コード)
    set荷主名(data.荷主名)
    set荷主請求ID(data.荷主請求ID)
    set更新日時(data.更新日時)
    set請求内訳id(data.荷主請求内訳ID)
    set計上基準日区分コード(data.計上基準日区分コード ?? "")
    set計上基準日区分名称(data.計上基準日区分名称1 ?? "")
    setコース編集(data.コース編集)
    setコンテナサイズ区分コード(data.コンテナサイズコード)
    setコンテナ軸区分コード(data.コンテナ軸コード)
  }

  const 請求initializedHandler = (grid: wjcGrid.FlexGrid) => {
    set請求支払GridInitialized(true)
    set請求FlexGrid(grid)
  }

  const 請求formatItemHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        if (
          ["付帯料金額", "高速料金額"].includes(e.getColumn().binding ?? "") &&
          e.getRow().dataIndex === 0
        ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
  }

  const 請求beginningEditHandler = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (
        ["付帯料金額", "高速料金額"].includes(e.getColumn().binding ?? "") &&
        e.getRow().dataIndex === 0
      ) {
        e.cancel = true
        return
      }
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    clearError()
    let messages: string[] = []
    let isError = false
    // 必須チェック
    const 必須Valid = 必須validate()
    isError = 必須Valid.hasError === true ? true : isError
    messages.push(...必須Valid.messages)

    if (isError) {
      dispatch(setWarningAlerts(messages))
      return
    }
    setIsConfirmModalShow(true)
  }

  /**
   * エラークリア
   */
  const clearError = () => {
    setIsInvalidパターンコード(false)
    setIsInvalid荷主コード(false)
    setIsInvalid表紙名(false)
    setIsInvalid受注部所(false)
    setIsInvalid請求内訳(false)
    dispatch(clearAlert())
  }

  /**
   * 必須チェック
   * @param putData: T受注配車入力GridItem[]
   */
  const 必須validate = () => {
    let 必須エラー = false
    let 受注部所コードエラー = false
    let パターンコード必須エラー = false
    let 表紙名エラー = false
    let 荷主コードエラー = false
    let 請求内訳エラー = false
    const エラーメッセージList: string[] = []
    if (受注パターンコード == null || 受注パターンコード === "") {
      パターンコード必須エラー = true
      setIsInvalidパターンコード(true)
      エラーメッセージList.push("受注パターンコードは必須入力です")
    }
    if (受注部所コード == null || 受注部所コード === "") {
      受注部所コードエラー = true
      setIsInvalid受注部所(true)
      エラーメッセージList.push("受注部所は必須入力です")
    }

    if (荷主コード == null || 荷主コード === "") {
      if (!荷主コードエラー) {
        荷主コードエラー = true
        setIsInvalid荷主コード(true)
        エラーメッセージList.push("荷主コードは必須入力です")
      }
    }
    if (荷主請求ID == null) {
      if (!表紙名エラー) {
        表紙名エラー = true
        setIsInvalid表紙名(true)
        エラーメッセージList.push("表紙名は必須入力です")
      }
    }
    if (請求内訳id == null) {
      if (!請求内訳エラー) {
        請求内訳エラー = true
        setIsInvalid請求内訳(true)
        エラーメッセージList.push("請求内訳は必須入力です")
      }
    }
    if (
      パターンコード必須エラー ||
      受注部所コードエラー ||
      表紙名エラー ||
      荷主コードエラー ||
      請求内訳エラー
    )
      必須エラー = true
    return {
      hasError: 必須エラー,
      messages: エラーメッセージList,
    }
  }

  /**
   * 送信
   */
  const submit = async (isMove: boolean) => {
    try {
      const service = new KaikonZyutyuHaisyaPatternService()
      let res: TApiResponse<boolean>
      if (id) {
        res = await service.put(id, getData())
        // 更新
      } else {
        // 登録
        res = await service.post(getData())
      }
      if (res) {
        isPrompt.current = false
        if (isMove) {
          history.goBack()
        } else {
          commonUtil.goToPageTop()
        }
        showInfoToast(`海コン受注配車の${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 送信データ作成
   */
  const getData = () => {
    const upsertData: TKaikonZyutyuHaisyaPatternGetRes = {
      受注配車パターンID: id ? parseInt(id) : undefined,
      受注配車パターンコード: 受注パターンコード,
      受注配車パターン名: 受注パターン名,
      荷主コード: 荷主コード,
      荷主名: 荷主名,
      荷主請求ID: 荷主請求ID ?? undefined,
      表紙名: 荷主請求ID?.toString() ?? "",
      コンテナサイズコード: コンテナサイズ区分コード ?? "",
      コンテナ軸コード: コンテナ軸区分コード ?? "",
      コース編集: コース編集,
      受注部所コード: 受注部所コード ?? undefined,
      運行部所コード: PICK情報?.積卸先コード
        ? PICK情報?.運行部所コード
        : 作業情報?.積卸先コード
        ? 作業情報?.運行部所コード
        : 返却情報?.積卸先コード
        ? 返却情報?.運行部所コード
        : その他情報?.積卸先コード
        ? その他情報?.運行部所コード
        : undefined,
      荷主請求内訳ID: 請求内訳id ?? undefined,
      請求運送料課税区分コード: 請求支払情報.data.items[0].運送料課税区分コード,
      請求運送料: 請求支払情報.data.items[0].運送料金額,
      請求付帯料課税区分コード: 請求支払情報.data.items[0].付帯料課税区分コード,
      請求付帯料: 請求支払情報.data.items[0].付帯料金額,
      請求高速料税込区分コード:
        請求支払情報.data.items[0].高速料金税込区分コード,
      請求高速料: 請求支払情報.data.items[0].高速料金額,
      請求備考: 請求支払情報.data.items[0].備考,
      支払運送料: 請求支払情報.data.items[1].運送料金額,
      支払付帯料: 請求支払情報.data.items[1].付帯料金額,
      支払高速料: 請求支払情報.data.items[1].高速料金額,
      支払備考: 請求支払情報.data.items[1].備考,
      計上基準日区分コード: 計上基準日区分コード ?? "",
      計上基準日区分名称1: 計上基準日区分名称 ?? "",
      更新日時: 更新日時 ?? "",
      PICK受注配車工程:
        PICK情報?.積卸先コード ||
        PICK情報?.運行部所コード ||
        PICK情報?.海コン付帯作業区分コード ||
        PICK情報?.海コン付帯作業手当 ||
        PICK情報?.乗務員食事手当
          ? PICK情報
          : undefined,
      作業受注配車工程:
        作業情報?.積卸先コード ||
        作業情報?.運行部所コード ||
        作業情報?.海コン作業内容 ||
        作業情報?.海コン付帯作業区分コード ||
        作業情報?.海コン付帯作業手当 ||
        作業情報?.乗務員食事手当
          ? 作業情報
          : undefined,
      返却受注配車工程:
        返却情報?.積卸先コード ||
        返却情報?.運行部所コード ||
        返却情報?.海コン付帯作業区分コード ||
        返却情報?.海コン付帯作業手当 ||
        返却情報?.乗務員食事手当
          ? 返却情報
          : undefined,
      その他受注配車工程:
        その他情報?.積卸先コード ||
        その他情報?.運行部所コード ||
        その他情報?.海コン作業内容 ||
        その他情報?.海コン付帯作業区分コード ||
        その他情報?.海コン付帯作業手当 ||
        その他情報?.乗務員食事手当
          ? その他情報
          : undefined,
    }
    return upsertData
  }

  /**
   * 削除モーダル
   */
  const beforeDeleteSubmit = () => {
    setIsConfirmDeleteModalShow(true)
  }

  /**
   * 削除
   */
  const deletePatten = async () => {
    try {
      const service = new KaikonZyutyuHaisyaPatternService()
      let res: TApiResponse<boolean>
      res = await service.delete(id)
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`海コン受注配車パターンの削除が完了しました`)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsConfirmDeleteModalShow(false)
    }
  }

  //#endregion
  return (
    <>
      <Form>
        <Container fluid>
          {/* 画面タイトル */}
          <Row className="page-title-row">
            <Col className="page-title-col">
              <span className="page-title">海コン受注配車パターン入力</span>
            </Col>
          </Row>
          {/* アラート表示 */}
          <Row>
            <Col>
              <AlertComponent />
            </Col>
          </Row>
          <Row>
            <Col>
              {/* 海コン受注カード */}
              <Card className="w-110rem">
                <Card.Header>
                  <FontAwesomeIcon icon={faFileImport}></FontAwesomeIcon>
                  <span>
                    {id
                      ? `海コン受注配車パターンコード： ${
                          searchResult?.受注配車パターンコード ?? ""
                        }
                        `
                      : "海コン受注配車パターン登録"}
                  </span>
                </Card.Header>
                <Card.Body>
                  <Container className="register-form" fluid>
                    <Row>
                      <Col>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">
                                パターン
                                <RequiredMark />
                              </th>
                              <td>
                                <div className="input-group">
                                  <TextInput
                                    className={
                                      isInvalidパターンコード ? "is-error" : ""
                                    }
                                    id="受注パターンコード"
                                    name="受注パターンコード"
                                    isReadOnly={id != null}
                                    value={受注パターンコード}
                                    setValue={set受注パターンコード}
                                    maxLength={20}
                                    placeholder="パターンCD"
                                  />
                                  <TextInput
                                    style={{ width: "22rem" }}
                                    id="受注配車パターン名"
                                    name="受注配車パターン名"
                                    value={受注パターン名}
                                    setValue={set受注パターン名}
                                    maxLength={
                                      VALIDATE_CONSTANT.LENGTH.一般名称
                                    }
                                    placeholder="パターン名"
                                  />
                                </div>
                              </td>
                              <th className="min-w-8rem">
                                受注部所
                                <RequiredMark />
                              </th>
                              <td>
                                <ComboBox.Busyo
                                  isEmpty={true}
                                  className={
                                    isInvalid受注部所 ? "is-error" : ""
                                  }
                                  itemsSource={部所ItemSource}
                                  isLoadEnded={受注部所isLoadEnded}
                                  setIsLoadEnded={set受注部所isLoadEnded}
                                  listFilter={(d) => d.運行部所フラグ === 1}
                                  isRequired={true}
                                  setSelectedValue={(v) => {
                                    v != null
                                      ? set受注部所コード(v)
                                      : set受注部所コード(userInfo.部所コード)
                                  }}
                                  selectedValue={受注部所コード}
                                  ComboBox={受注部所ComboBox}
                                  setComboBox={
                                    set受注部所ComboBox
                                  }></ComboBox.Busyo>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">
                                荷主
                                <RequiredMark />
                              </th>
                              <td>
                                <div className="input-group">
                                  <TextInput
                                    style={{ width: "6rem" }}
                                    id="荷主コード"
                                    name="荷主コード"
                                    value={荷主コード}
                                    setValue={(v) => {
                                      set荷主コード(v)
                                      荷主取得(v)
                                    }}
                                    className={
                                      isInvalid荷主コード ? "is-error" : ""
                                    }
                                    maxLength={
                                      VALIDATE_CONSTANT.LENGTH.荷主コード
                                    }
                                    placeholder="荷主CD"
                                  />
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault()
                                      setIs荷主検索Modal(true)
                                    }}
                                    type="button"
                                    className="icon-button">
                                    <FontAwesomeIcon
                                      className="icon-button-inner"
                                      icon={faSearch}></FontAwesomeIcon>
                                  </button>
                                  <TextInput
                                    style={{ width: "30rem" }}
                                    isReadOnly={true}
                                    id="荷主名"
                                    name="荷主名"
                                    value={荷主名}
                                    setValue={set荷主名}
                                    maxLength={100}
                                    placeholder="荷主名"
                                  />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <th className="min-w-8rem">
                                表紙名
                                <RequiredMark />
                              </th>
                              <td>
                                <div className="w-20rem">
                                  <ComboBox.HyosiBunkatu
                                    itemsSource={荷主請求ItemSource}
                                    isLoadEnded={表紙分割IsLoadEnded}
                                    setIsLoadEnded={set表紙分割IsLoadEnded}
                                    isEmpty={true}
                                    className={
                                      isInvalid表紙名 ? "is-error" : ""
                                    }
                                    setSelectedValue={(v) => {
                                      if (v === 0) {
                                        set荷主請求ID(undefined)
                                      } else {
                                        set荷主請求ID(v)
                                        荷主請求Ref.current = v
                                      }
                                    }}
                                    selectedValue={荷主請求ID}
                                    ComboBox={表紙分割ComboBox}
                                    setComboBox={set表紙分割ComboBox}
                                  />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">コンテナサイズ</th>
                              <td>
                                <ComboBox.Kubun
                                  className="w-15rem"
                                  分類コード={
                                    区分分類コード.受注配車_請求支払
                                      .コンテナサイズ
                                  }
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={コンテナサイズIsLoadEnded}
                                  setIsLoadEnded={setコンテナサイズIsLoadEnded}
                                  setSelectedValue={(v) => {
                                    setコンテナサイズ区分コード(v)
                                  }}
                                  selectedValue={コンテナサイズ区分コード}
                                  ComboBox={コンテナサイズComboBox}
                                  setComboBox={setコンテナサイズComboBox}
                                />
                              </td>
                              <th className="min-w-8rem">コンテナ軸</th>
                              <td>
                                <ComboBox.Kubun
                                  className="w-15rem"
                                  分類コード={
                                    区分分類コード.受注配車_請求支払.コンテナ軸
                                  }
                                  itemsSource={区分ItemSource}
                                  isLoadEnded={コンテナ軸IsLoadEnded}
                                  setIsLoadEnded={setコンテナ軸IsLoadEnded}
                                  setSelectedValue={(v) => {
                                    setコンテナ軸区分コード(v)
                                  }}
                                  selectedValue={コンテナ軸区分コード}
                                  ComboBox={コンテナ軸ComboBox}
                                  setComboBox={setコンテナ軸ComboBox}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
              <Card className="w-110rem">
                <Card.Header>
                  <FontAwesomeIcon icon={faTruck}></FontAwesomeIcon>
                  <span>海コン作業工程配車</span>
                </Card.Header>
                <Card.Body>
                  <Container className="register-form" fluid>
                    <Row>
                      <Col>
                        <Table className="transpose-table">
                          <thead>
                            <tr className="w-8rem">
                              <th className="row-header">作業工程</th>
                              <th className="row-header">積卸先コード</th>
                              <th className="row-header">社名（ヤード）</th>
                              <th className="row-header">都道府県</th>
                              <th className="row-header">市区町村</th>
                              <th className="row-header">作業内容</th>
                              <th className="row-header">運行部所</th>
                              <th className="row-header">乗務員売上額</th>
                              <th className="row-header">食事手当</th>
                              <th className="row-header">付帯高速料</th>
                              <th className="row-header">付帯作業分類</th>
                              <th className="row-header">付帯作業手当</th>
                              <th className="row-header">工程備考</th>
                              <th className="row-header">作業工程</th>
                            </tr>
                          </thead>
                          <tbody>
                            <SagyoGridRow
                              initState={initPICK情報}
                              setState={setPICK情報}
                              ninusiCode={荷主コード}
                              kubunItemSource={区分ItemSource}
                              busyoItemSource={部所ItemSource}></SagyoGridRow>
                            <SagyoGridRow
                              initState={init作業情報}
                              setState={set作業情報}
                              ninusiCode={荷主コード}
                              kubunItemSource={区分ItemSource}
                              busyoItemSource={部所ItemSource}></SagyoGridRow>
                            <SagyoGridRow
                              initState={init返却情報}
                              setState={set返却情報}
                              ninusiCode={荷主コード}
                              kubunItemSource={区分ItemSource}
                              busyoItemSource={部所ItemSource}></SagyoGridRow>
                            <SagyoGridRow
                              initState={initその他情報}
                              setState={setその他情報}
                              ninusiCode={荷主コード}
                              kubunItemSource={区分ItemSource}
                              busyoItemSource={部所ItemSource}></SagyoGridRow>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
              <Card className="w-110rem">
                <Card.Header>
                  <span>
                    <FontAwesomeIcon
                      icon={faFileInvoiceDollar}></FontAwesomeIcon>
                    海コン請求支払情報
                  </span>
                </Card.Header>
                <Card.Body>
                  <Container className="register-form" fluid>
                    <Row>
                      <Col>
                        <div>
                          <Table className="form-table">
                            <tbody>
                              <tr>
                                <th className="min-w-8rem">
                                  請求内訳
                                  <RequiredMark />
                                </th>
                                <td className="w-8rem">
                                  <div className="w-20rem">
                                    <ComboBox.SeikyuUtiwake
                                      isEmpty={true}
                                      className={
                                        isInvalid請求内訳 ? "is-error" : ""
                                      }
                                      itemsSource={請求内訳ItemSource}
                                      isLoadEnded={請求内訳IsLoadEnded}
                                      setIsLoadEnded={set請求内訳IsLoadEnded}
                                      setSelectedValue={(v) => {
                                        set請求内訳id(v)
                                      }}
                                      selectedValue={請求内訳id}
                                      ComboBox={請求内訳ComboBox}
                                      setComboBox={set請求内訳ComboBox}
                                    />
                                  </div>
                                </td>
                                <th className="min-w-8rem">請求基準日</th>
                                <td>
                                  <TextInput
                                    id="計上基準日区分"
                                    name="計上基準日区分"
                                    isReadOnly
                                    value={計上基準日区分名称}
                                    setValue={(v) => {
                                      set計上基準日区分名称(v)
                                    }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <div>
                          <Button
                            className="mx-2"
                            type="button"
                            disabled={isSearching}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                            }}>
                            <FontAwesomeIcon icon={faSearch} />
                            受注請求履歴
                          </Button>
                          <Button
                            className="mx-2"
                            type="button"
                            disabled={isSearching}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                            }}>
                            <FontAwesomeIcon icon={faSearch} />
                            運賃タリフ参照
                          </Button>
                        </div>
                        <wjrGrid.FlexGrid
                          {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                          itemsSource={請求支払情報.data}
                          initialized={請求initializedHandler}
                          allowSorting={false}
                          formatItem={請求formatItemHandler}
                          beginningEdit={請求beginningEditHandler}
                          allowDragging={wjcGrid.AllowDragging.None}
                          isReadOnly={false}>
                          <wjrGrid.FlexGridColumn
                            binding="種別"
                            cssClassAll={"read-only-cell"}
                            isReadOnly={true}
                            header="請求支払"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="運送料課税区分コード"
                            width={80}
                            dataMap={課税区分DataMap}
                            header="課税"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="運送料金額"
                            header="運送料"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="付帯料課税区分コード"
                            width={80}
                            dataMap={課税区分DataMap}
                            header="課税"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="付帯料金額"
                            header="付帯料"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="高速料金税込区分コード"
                            width={70}
                            isReadOnly={true}
                            cssClassAll={"read-only-cell"}
                            dataMap={税込区分DataMap}
                            header="税表示"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="高速料金額"
                            header="高速料"></wjrGrid.FlexGridColumn>
                          <wjrGrid.FlexGridColumn
                            binding="備考"
                            width={500}
                            align={"left"}
                            header="請求支払備考(付帯作業内容でも使用)"></wjrGrid.FlexGridColumn>
                        </wjrGrid.FlexGrid>
                      </Col>
                    </Row>
                  </Container>
                  <Container className="register-form mt-3" fluid>
                    <Row>
                      <Col>
                        <Table className="form-table">
                          <tbody>
                            <tr>
                              <th className="min-w-8rem">コース編集</th>
                              <td>
                                <TextInput
                                  style={{ width: "50rem" }}
                                  id="コース編集"
                                  name="コース編集"
                                  value={コース編集}
                                  setValue={(v) => {
                                    setコース編集(v)
                                  }}
                                  placeholder="コース編集"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {id == null && (
                          <Button
                            variant="waiting"
                            className="me-4"
                            onClick={(e) => {
                              beforeSubmit()
                              setIsPageMove(false)
                            }}>
                            続けて登録
                          </Button>
                        )}
                        <Button
                          variant="waiting"
                          onClick={(e) => {
                            beforeSubmit()
                            setIsPageMove(true)
                          }}>
                          {id ? "更新" : "登録して戻る"}
                        </Button>
                        <Button
                          size="lg"
                          className="ms-4"
                          variant="caution"
                          disabled={!id}
                          onClick={(e) => beforeDeleteSubmit()}>
                          削除
                        </Button>
                        <Button
                          type="button"
                          className="ms-4"
                          variant="secondary"
                          onClick={() => history.goBack()}>
                          一覧に戻る
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </Form>
      {/* 荷主検索 */}
      <NinusiSeikyuSearchModal
        isShow={is荷主検索Modal}
        setIsShow={setIs荷主検索Modal}
        setNinusi={(荷主) => {
          set荷主コード(荷主.荷主コード)
          set荷主名(荷主.荷主名)
          荷主取得(荷主.荷主コード)
        }}></NinusiSeikyuSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={() => {
          submit(isPageMove)
        }}>
        入力された内容で{id ? "更新" : "登録"}しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isConfirmDeleteModalShow}
        hideHandler={setIsConfirmDeleteModalShow}
        submitHandler={deletePatten}>
        表示のパターンを削除しますか？
      </ConfirmModal>
    </>
  )
}

export default KaikonZyutyuHaisyaPatternRegister
